"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createScript(scriptSrc, document) {
    if (document === void 0) { document = window.document; }
    var promise = new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.onload = function () {
            resolve();
        };
        script.onerror = function () {
            var err = "Error loading script '".concat(scriptSrc, "'");
            reject(err);
        };
        script.async = true;
        script.src = scriptSrc;
        document.getElementsByTagName("head")[0].appendChild(script);
    });
    return promise;
}
exports.default = createScript;
